<template>
  <div class="form-group">
    <form @submit.prevent="onSubmit">
      <!-- PROJECT -->
      <b-form-group id="form-project" label="Select a project:" label-for="form-project-input">
        <ejs-dropdownlist
            id="project-dropdownlist"
            :dataSource='projectDataList'
            :fields="projectDataFields"
            :v-model="project"
            placeholder='Select a project'
            @change="setProjectHead(originalProjectDataList, projectDataList)"
        ></ejs-dropdownlist>
        <div v-if="$v.project.$dirty">
          <div v-if="!$v.project.required" class="error">Field is required</div>
        </div>
      </b-form-group>

      <!--PROJECT HEAD-->
      <div class="form-group">
        <label for="projectHead"> Project Head(P.I)</label>
        <input id="projectHead" v-model="projectHeadName" class="form-control" disabled type="text"/>
      </div>

      <!-- SAMPLE COLLECTION LOCATION -->
      <b-form-group id="form-locationCollected" label="Select Location:" label-for="form-loc-input">
        <ejs-dropdownlist
            id="location-dropdownlist"
            :dataSource='locationDataList'
            :fields="locationDataFields"
            :v-model="locationCollected"
            placeholder='Select location sample(s) was collected from'
            @change="locationCollected = setDropDownItemValue('location-dropdownlist', locationDataList)"
        ></ejs-dropdownlist>
        <div v-if="$v.locationCollected.$dirty">
          <div v-if="!$v.locationCollected.required" class="error">Field is required</div>
        </div>
      </b-form-group>

      <!-- DATE PICKER -->
      <div>
        <date-range-picker></date-range-picker>
        <div v-if="$v.date_from.$dirty || $v.date_to.$dirty">
          <div v-if="!$v.date_from.required || !$v.date_to.required" class="error">Field is required</div>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-dark btn-rounded" type="submit">Search</button>
      </div>
    </form>
  </div>
</template>

<script>
import DateRangePicker from "@/components/DateRangePicker";
import EventBus from "@/components/EventBus";
import {required} from "vuelidate/lib/validators";
import {
  getLocationCollected, getProjectDataList,
  handleError, pageStartLoader,
  setDropDownItemValue, setProjectHead,
} from "@/utils/util_functions";
import axios from "axios";
import {sample_resource} from "@/utils/api_paths";

export default {
  name: "SampleListViewFilter",
  components: {DateRangePicker},
  data() {
    return {
      project: null,
      projectHeadName: null,
      projectHeadEmail: null,
      projectDataList: [],
      projectDataFields: {},
      originalProjectDataList: [],

      locationCollected: null,
      locationDataList: [],
      locationDataFields: {},

      date_from: null,
      date_to: null,
    }
  },

  validations: {
    project: {required},
    locationCollected: {required},
    date_from: {required},
    date_to: {required},
  },

  mounted() {
    EventBus.$on('get-location-data-list', payload => {
      this.locationDataList = payload['items']
      this.locationDataFields = payload['fields']
    })

    EventBus.$on('get-project-data-list', payload => {
      this.originalProjectDataList = payload['projectList']
      this.projectDataList = payload['selectorList']['items']
      this.projectDataFields = payload['selectorList']['fields']
    })

    EventBus.$on('set-project-head-details', payload => {
      this.project = payload['project']
      this.projectHeadName = payload['name']
      this.projectHeadEmail = payload['email']
    })

    EventBus.$on('date-range-set', payload => {
      this.date_from = payload['from']
      this.date_to = payload['to']
    })
  },

  methods: {
    setProjectHead, setDropDownItemValue,

    onSubmit(evt) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        evt.preventDefault()
        return;
      }
      this.fetchSamples()
    },

    fetchSamples() {
      let loader = pageStartLoader(this)
      axios.get(sample_resource, {
        headers: {
          location: this.locationCollected, project: this.project,
          from: this.date_from, to: this.date_to
        }
      }).then((res) => {
        setTimeout(() => {
          loader.hide()
          EventBus.$emit('sample-data-to-cart', res.data.message);
        }, 2000)
      })
          .catch((error) => {
            handleError(this, error, loader)
          });
    }
  },
  created() {
    getProjectDataList();
    getLocationCollected();
  }
}
</script>
